import $ from 'jquery';


// 日付を比較して1ヶ月以内ならアイコンをつける
const setIcon = () => {

  const $item = $('#js-checkNew').find('li');
  const today = new Date();

  // NEWアイコンのクラスをつける関数
  const addIcon = (elm) => {
    elm.addClass('buttonList_item-new');
  }

  // 対象の数だけ処理する
  $item.each(function() {
    let entryDate = $(this).attr('data-day') + ' 00:00:00';
    let term      = new Date(today - (+new Date(entryDate)));
    let year      = term.getFullYear() - 1970;
    let month     = term.getMonth();
    let day       = term.getDate() - 1;

    // 1年以内の場合のみ処理する
    if(year < 1) {

      // 1ヶ月以内ならアイコンをつける
      if(month < 1) {
        addIcon($(this));
      }

      // ぴったり1ヶ月のときもアイコンをつける
      if(month === 1) {
        if(day === 0) {
          addIcon($(this));
        }
      }
    }
  });
}

module.exports = {
  setIcon : setIcon
};



// WEBPACK FOOTER //
// ./src/js/modules/top.js